/**
 * Utility to determine if a navigation or menu item is currently active, especially for nested routes.
 *
 * Checks if the given item path matches the current route pathname.
 * Useful for highlighting active menu items in navigation components.
 *
 * @param itemPath - The path of the item to check.
 * @param pathname - The current route pathname.
 * @returns True if the item is active, false otherwise.
 */

import { matchPath } from 'react-router-dom'

export const isItemActive = (itemPath: string, pathname: string) => {
  const base = itemPath.replace(/\/+$/, '') || '/'
  if (base === '/') return pathname === '/'
  return (
    !!matchPath({ path: base, end: true }, pathname) ||
    !!matchPath({ path: `${base}/*`, end: false }, pathname)
  )
}
